import { useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { EnvelopeFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as yup from "yup";

import { ContactTypeEnum } from "@/enum/common";
import { handleAxiosSuccess } from "@/helpers/common";
import { ROUTES } from "@/helpers/routes";
import { saveContactService } from "@/services/contactService";
import InputTextField from "@/shared/components/inputTextField";
import PageSeo from "@/shared/components/PageSeo";
import TextAreaField from "@/shared/components/TextAreaField";
import { IContactForm } from "@/types/common";

import Layout from "../shared/components/layout";

const schema = yup
    .object({
        firstName: yup.string().required("This is a required field."),
        lastName: yup.string().required("This is a required field."),
        email: yup.string().email().required("This is a required field."),
        company: yup.string().optional(),
        message: yup.string().required("This is a required field."),
        type: yup.string().required("This is a required field."),
    })
    .required();
export default function Newsletter() {
    const [isLoading, setIsLoading] = useState(false);
    const [isContactSaved, setContactSaved] = useState(false);
    const [fromEmail, setfromEmail] = useState("");
    const { control, handleSubmit }
        = useForm({
            mode: "all",
            resolver: yupResolver(schema),
            defaultValues: {
                firstName: "",
                company: "",
                email: "",
                lastName: "",
                message: "",
                type: ContactTypeEnum.contact,

            },
        });
    const onSubmit = async (data: IContactForm) => {
        setIsLoading(true);

        const formData: IContactForm = {
            ...data,
        };
        setfromEmail(data.email);
        const res = await saveContactService(formData);
        handleAxiosSuccess(res.data.message, toast);
        setIsLoading(false);
        setContactSaved(true);

        gtag("event", "Contact Form", { description: "Contact Page" });

        return false;
    };

    return (
        <div>
            <PageSeo title="Contact Us | The Gender Index" pathname={ROUTES.contact} />
            <Layout>
                <div className='singleLayout contactPage'>
                    <div className='flexDv'>
                        <h3>Contact the TGI team</h3>
                        <p className='body-default-copy-large contactText'>If you would like to learn more about The Gender Index, the team behind the project,
                            our data or anything else, please feel free to reach out to us below:</p>
                        {/* <div className='address'>
                            <p className='body-default-copy-large'>hello@thegenderindex.co.uk</p>
                            <p className='body-default-copy-large'>079877656554</p>
                            <p className='body-default-copy-large'>@thegenderindex</p>
                        </div>
                        <p className='body-default-copy-large'><strong>The Gender Index,</strong> The Beehive, City Place, Gatwick, RH6 0PA</p> */}
                    </div>
                    <div className='flexDv'>
                        {!isContactSaved
                            ? <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="name2Column">
                                    <InputTextField placeholder="First name" name="firstName" control={control} />
                                    <InputTextField placeholder="Surname" name="lastName" control={control} />
                                </div>
                                <InputTextField placeholder="Email address" name="email" control={control} />
                                <InputTextField placeholder="Company (optional)" name="company" control={control} />
                                <TextAreaField placeholder="Enter message..." name="message" control={control} />
                                <div className='action'>
                                    <button className='btn-pink btn-small' type="submit" disabled={isLoading}>Send</button>
                                </div>
                            </form>
                            : <div className="messageReceivedBox">
                                <div className="content">
                                    <h5><EnvelopeFill /> Message received</h5>
                                    <p className="body-default-copy-medium">Thank you for sending us a message from <a className="linkText" style={{ "fontSize": "0.875rem" }}>{fromEmail}</a>.
                                        A member of the TGI team will come back to you shortly.</p>
                                </div>
                            </div>
                        }
                    </div>

                </div>
            </Layout>
        </div>
    );
}

